// Dia local num fuso IANA, como YYYY-MM-DD.
//
// O pulso do "Meu Trabalho" pivota no dia de Europe/Amsterdam (decisão
// 33634c8c): a população do módulo vive e trabalha lá, e o UNIQUE
// (user_id, entry_day, entry_type) do banco precisa de UM dia canônico —
// um aparelho em fuso brasileiro à meia-noite não pode abrir um segundo
// pulso do mesmo dia holandês.
//
// en-CA formata nativamente como YYYY-MM-DD (mesmo truque do sv-SE já usado
// no useTaskVoiceCapture) — sem parse manual, com DST resolvido pelo Intl.
export const MYWORK_PULSE_TZ = "Europe/Amsterdam";

export function localDayFor(timeZone: string, now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
}
